export const cruiseLinesList = [
    'Carnival',
    'Holland America',
    'P&O',
    'Virgin Voyages',
    'Princess',
    'MSC'
]